import React, { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Popups from "../Modals/Popups";
import PersonalizedActionModal from "../Modals/PersonalizedActionModal";

export default function Banner() {
  const [show, setShow] = useState(false);
  const controls = useAnimation();

  // ✅ Trigger animation only once
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsLargeScreen(window.innerWidth >= 992);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    if (inView && isLargeScreen) {
      controls.start({
        y: 0,
        opacity: 1,
        transition: { duration: 1.5, ease: "easeOut" },
      });
    }
  }, [inView, controls, isLargeScreen]);

  return (
    <div className="row py-md-5 py-2 mx-3_5-0 px-3">
      <motion.div
        ref={ref}
        className="col-12 banner-border overflow-hidden d-flex justify-content-center align-items-center"
        initial={isLargeScreen ? { y: 150, opacity: 0 } : {}}
        animate={isLargeScreen ? controls : {}}
      >
        <div className="banner-content text-center">
          <h2 className="banner-heading mb-md-3 mb-1">
            Ready to turn your idea into reality?
          </h2>
          <h3 className="banner-heading mb-md-5 mb-3">Let's get started!</h3>
          <div className="d-flex justify-content-center">
            <button
              className="banner-button d-flex align-items-center justify-content-between"
              onClick={() => setShow(true)}
            >
              <label>Get a free consultation</label>
              <img
                src="/images/AboutUs/icons/arrow-right.svg"
                alt="arrow"
                className="banner-button-img"
              />
            </button>
          </div>
        </div>
      </motion.div>

      {/* Modal */}
      <Popups show={show} setShow={setShow} title="FREE CONSULTATION" size="lg">
        <PersonalizedActionModal />
      </Popups>
    </div>
  );
}
